import { State, ZoomLevel } from "../state";

export interface ChangeZoomLevelAction {
  type: "CHANGE ZOOM LEVEL";
  zoom: ZoomLevel;
}

export const changeZoomLevel = (state: State, action: ChangeZoomLevelAction): State => {
  if (state.editTable) {
    return {
      ...state,
      tableZoom: action.zoom
    };
  }
  return {
    ...state,
    zoom: action.zoom,
  };
};
